var map = {
	"./BREEZE-v1.1.json": 2925,
	"./CHICKADEE-v2.3.json": 8622,
	"./COMFORT-VIVID-v2.2.json": 435,
	"./COMFORT-VIVID-v3.1.json": 2592,
	"./COMFORT-VIVID-v4.0.json": 7003,
	"./COMFORT-VIVID-v4.2.json": 8928,
	"./COMFORT-VIVID-v4.3.json": 13,
	"./Industrial-Transceiver-1wire-v1.11.json": 2564,
	"./Industrial-Transceiver-v2.1.json": 9894,
	"./KIWI-ALL-PORT-10-v2.0.json": 6377,
	"./KIWI-CLOVER-v2.0.json": 629,
	"./KIWI-v2.0.json": 7891,
	"./MEMO-(demo).json": 9002,
	"./ORCA-v0.14.json": 8971,
	"./ORCA-v1.0.json": 2598,
	"./SEAL-v1.json": 5141,
	"./SPARROW-PELICAN-v2.8.json": 561,
	"./SPARROW-PELICAN-v3.1.json": 3252,
	"./STORK-v2.0.json": 7320,
	"./STORK-v2.1.json": 2158,
	"./STORK-v2.2.json": 4024,
	"./TUNDRA-v2.1.json": 5176,
	"./eBeat-v1.0.json": 3566,
	"./eBeat-v1.x.json": 1843,
	"./eDoctor-v0.15.json": 5451,
	"./eDoctor-v1.2.json": 9230,
	"./eDoctor-v1.json": 575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3179;